import React, {Component} from "react";
import {Button, Col, Row} from "reactstrap";
import Dropzone from "react-dropzone";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./FileDropzone.scss";
import {commons} from "@mc/mc-legacy";
import FileDropzoneListItem from "./FileDropzoneListItem";
import {H3} from "@mc/ui-v3";

const {sinkEvent} = commons;
/**
 * Je potřeba přidat react-dropzone do dependencies v projektu kde se tohle používá.
 */

export default class FileDropzone extends Component {
    static propTypes = {
        onDeleteFile: PropTypes.func,
        onAddFile: PropTypes.func,
        files: PropTypes.array,
        readOnly: PropTypes.bool,
        noItemsLabel: PropTypes.string,
        isDragMode: PropTypes.bool,
        onCreatePhoto: PropTypes.func,
        multiple: PropTypes.bool,
        accept: PropTypes.string,
        setAttachment: PropTypes.func,
    };
    static defaultProps = {
        readOnly: false,
        multiple: false,
    };
    state = {
        fileIndex: 0,
        isOpen: false,
        viewType: false,
    };

    render() {
        const {files, readOnly, multiple, isDragMode, accept, onAddFile, onDeleteFile, setAttachment} = this.props;
        const dropzoneClass = "file-dropzone w-100 h-100 d-flex justify-content-center align-files-center";
        const dropzoneProps = {
            disabled: readOnly,
            onDrop: onAddFile,
            accept: accept,
            className: dropzoneClass,
            multiple: multiple,
        };
        const cls = classNames(
            {
                "file-dropzone-border-wrapper": isDragMode,
            },
            "flex-column",
            "file-dropzone-wrapper"
        );
        return (
            <div className={cls}>

                <Dropzone {...dropzoneProps}>
                    {({getRootProps, getInputProps, isDragActive}) => {
                        const cls = classNames(["w-100", "h-100", "dropzone-label-wrapper"], {
                            "drag-active": isDragActive,
                        });
                        return (
                            <div className={cls} {...getRootProps()}>
                                <div>
                                    <input {...getInputProps()} />


                                </div>
                                <div className={"card-scrollable container-fluid"}>
                                    <div className={"card-scrollable-content"}>
                                        <Row noGutters className={cls}>
                                            <Col className={"flex-column"}>
                                                <div className={"items-list bordered h-100"}>
                                                    {files.length<1 &&<div className="h-100 d-flex justify-content-center align-items-center"> <H3 className="mt-2">Přetáhněte soubory pro nahrání</H3></div>}
                                                    {files.length>0 &&
                                                        files.map((fileUploaded, index) => {
                                                            return (
                                                                <FileDropzoneListItem
                                                                    key={index}
                                                                    index={index}
                                                                    file={fileUploaded}
                                                                    onDeleteFile={onDeleteFile}
                                                                    setAttachment={setAttachment}
                                                                />
                                                            );
                                                        })}
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                            </div>
                        );
                    }}
                </Dropzone>


            </div>
        );
    }
}
